import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { assign } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, Autocomplete, Select, Form } from '~/components/Form';
import { Spinner } from '~/components';
import { t } from '~/helpers';
import {
  storeTanquesVirtual,
  updateTanquesVirtual,
} from '~/store/modules/tanquevirtual/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();
  const { loading, find, params } = useSelector((state) => state.tanquevirtual);

  const optionsProduct = useMemo(
    () => [
      { value: 1, label: 'Alcool' },
      { value: 2, label: 'Gasolina' },
      { value: 3, label: 'Diesel' },
    ],
    []
  );

  const optionsStatus = useMemo(
    () => [
      { value: 1, label: 'Liberado' },
      { value: 2, label: 'Bloqueado' },
      { value: 3, label: 'Cancelado' },
    ],
    []
  );

  const initials = create ? data : { ...find, ...data };

  const handleSubmit = useCallback(
    async (param) => {
      try {
        const schema = Yup.object().shape({
          tavi_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(2, t('s.geral.validacao.tamanhominimo').replace('%s', 2))
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10)),
          tavi_nome: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(2, t('s.geral.validacao.tamanhominimo').replace('%s', 2))
            .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50)),
          poco_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
            .nullable(),
          prod_codigo: Yup.number().required(
            t('s.geral.validacao.campoobrigatorio')
          ),
          tavi_status: Yup.number().required(
            t('s.geral.validacao.campoobrigatorio')
          ),
        });

        await schema.validate(param, {
          abortEarly: false,
        });

        const objSend = {
          ...initials,
          ...param,
        };

        if (create) dispatch(storeTanquesVirtual(objSend, params));
        else dispatch(updateTanquesVirtual(objSend, params));
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        }
      }
    },
    [initials, create]
  );

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form
          ref={reference}
          initialData={assign({ tavi_status: 1 }, initials)}
          onSubmit={handleSubmit}
        >
          <Input name="tavi_codigo" label="Código" disabled={!create} />

          <Input name="tavi_nome" label="Descrição" />

          <Autocomplete
            name="poco_codigo"
            label="poco_descricao"
            title="Posto"
            url="postoscomboios"
            unique="poco_codigo"
            disabled={!create}
            hiddens={[{ name: 'poco_descricao' }]}
          />

          <Select name="prod_codigo" label="Produto" options={optionsProduct} />

          <Select name="tavi_status" label="Status" options={optionsStatus} />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
